import { render, staticRenderFns } from "./square-selected.mpx?vue&type=template&id=06a52d08&isComponent&outputPath=components%2Fsquare-selected04b53ad4%2Findex"
import script from "./square-selected.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fsquare-selected04b53ad4%2Findex"
export * from "./square-selected.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fsquare-selected04b53ad4%2Findex"
import style0 from "./square-selected.mpx?vue&type=style&index=0&id=06a52d08&prod&lang=stylus&mpxStyleOptions=%7B%22mid%22%3A%22_04b53ad4%22%7D&isComponent&outputPath=components%2Fsquare-selected04b53ad4%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports